<template>
  <section>
    <b-table
      :loading="isLoading"
      :striped="true"
      :hoverable="true"
      default-sort="score"
      default-sort-direction="desc"
      :data="rankingData"
      paginated
      backend-pagination
      :total="totalData"
      @page-change="page = $event"
      :current-page="page"
      :per-page="perPage"
    >
      <template slot-scope="props">
        <!-- <b-table-column label="" field="">
          <b-tooltip :label="props.row.old_rider == true ? 'Jinete antiguo' : 'Jinete Actual' " position="is-right">
            <b-icon icon="account-arrow-left" type="is-danger" v-if="props.row.old_rider"/>
            <b-icon  icon="account-check" type="is-success" v-else/>
          </b-tooltip>
        </b-table-column> -->
        <b-table-column label="#" field="id" centered>
          <h4 class="title is-3">{{ props.row.position}}</h4>
        </b-table-column>
        <b-table-column label="Jinete" field="name">
          <link-to-detail type="rider" :resource-id="props.row.rider_id"> {{`${props.row.rider_lastname} ${props.row.rider_name}`}} </link-to-detail>
        </b-table-column>
        <b-table-column label="Caballo" field="name">
          <link-to-detail type="horse" :resource-id="props.row.horse_id">
          <horse-gender :gender-code="'f'" v-if="props.row.horse_gender  == 'F'" />
          <horse-gender :gender-code="'m'" v-else-if="props.row.horse_gender  == 'M'" />
          {{`${props.row.horse_name}`}} </link-to-detail>
        </b-table-column>
        <b-table-column label="Padres" field="name">
          <p><b-icon icon="gender-male" size="is-small" type="is-info"></b-icon> {{ props.row.father_name ? props.row.father_name : 'S/I'}} </p>
          <p><b-icon icon="gender-female" size="is-small" type="is-danger"></b-icon> {{ props.row.mother_name ? props.row.mother_name : 'S/I'}} </p>
        </b-table-column>
        <b-table-column label="Edad" field="age" centered>
          {{ props.row.horse_age ? `${props.row.horse_age.years} - ${props.row.horse_age.months}`: 'S/I'}}
        </b-table-column>
        <b-table-column label="Nivel Actual" field="start_at" centered >
          <lesson-pdf-button :type="props.row.status" v-if="props.row.status" :lesson-id="props.row.current_lesson_id" :text="props.row.current_lesson_name"/>
          <lesson-pdf-button v-else :lesson-id="props.row.current_lesson_id" :text="props.row.current_lesson_name"/>
        </b-table-column>
        <b-table-column label="Fre" field="frecuencia" centered>
          {{ props.row.frequency}}
        </b-table-column>
        <b-table-column label="Puntaje" field="score" centered>
          <score-tag :score="props.row.score"/>
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando Resultados...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay Resultados&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </section>
</template>

<script>
import ScoreTag from '@/components/ScoreTag.vue'
import LinkToDetail from '@/components/LinkToDetail'
import HorseGender from '@/components/HorseGender'
import LessonPdfButton from '@/components/LessonPDFButton'
import RankingService from '@/services/RankingService'
import LessonService from '@/services/LessonService.js'

export default {
  components: {
    ScoreTag,
    LinkToDetail,
    HorseGender,
    LessonPdfButton
  },
  created () {
    this.getRanking()
  },
  props: {
    lessonId: {
      required: false,
      type: Number,
      default: 0
    },
    fromDate: {
      required: false,
      type: Date,
      default: () => new Date().setMonth(new Date().getMonth() - 1)
    },
    toDate: {
      required: false,
      type: Date,
      default: () => new Date()
    }
  },
  data () {
    return {
      rankingPositions: [],
      rankingData: [],
      isLoading: false,
      totalData: 0,
      perPage: 100,
      page: 1,
      active: 1,
    }
  },
  methods: {
    async getRanking () {
      this.isLoading = true
      let response = await RankingService.getRanking({
        'lessons[0]': this.lessonId === 0 ? null : this.lessonId,
        'from': this.$moment(this.fromDate).format('YYYY-MM-DD').toString(),
        'to': this.$moment(this.toDate).format('YYYY-MM-DD').toString(),
        'page': this.page,
        'per_page': this.perPage,
        'active': this.active
      })
      this.totalData = response.data.meta.total
      this.rankingData = response.data.data
      let lessonsResponse = await LessonService.getLessons()
      let lessons = lessonsResponse.data.data

      this.extractTopRanking(lessons)
    },
    extractTopRanking (lessons) {
      this.rankingData.forEach(item => {
        if (item.lesson_status) {
          if (item.lesson_status === 'medium') {
            item['status'] = 'is-warning'
          } else if (item.lesson_status === 'high') {
            item['status'] = 'is-success'
          } else if (item.lesson_status === 'low') {
            item['status'] = 'is-danger'
          }
        }
      })
      this.isLoading = false
    },
    sortByDate (a, b, isAsc) {
      if (isAsc) {
        return (
          new Date(b.start_date).getDate() - new Date(a.start_date).getDate()
        )
      } else {
        return (
          new Date(a.start_date).getDate() - new Date(b.start_date).getDate()
        )
      }
    }
  },
  watch: {
    lessonId (value) {
      this.getRanking()
    },
    fromDate (value) {
      this.getRanking()
    },
    toDate (value) {
      this.getRanking()
    },
    page (value) {
      this.getRanking()
    },
    totalData (value) {
      this.$emit('number-result-changed', value)
    }
  }
}
</script>

<style scoped>
  .gender-male > *{
    color: #2196F3 !important;
  }

  .gender-female{
    color: #E91E63;
  }

</style>
